import React from "react";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";


function KpiStatusBarChart(props) {
    const kpiStatusDict = props.kpiStatus[0];
    const kpiLabels = [];
    const kpiPassValues = [];
    const kpiFailValues = [];
    const kpipassColor = [];
    const kpiFailColor = [];
    for (var key in kpiStatusDict) {
        if (
            key.startsWith("l0") ||
            key.startsWith("l1") ||
            key.startsWith("rss")
        ) {
            kpiLabels.push(key);
            if (kpiStatusDict[key] == "pass") {
                kpiPassValues.push(1);
                kpipassColor.push("#00FF00");
            } else {
                kpiPassValues.push(0);
                kpipassColor.push("#00FF00");
            }

            if (kpiStatusDict[key] == "fail") {
                kpiFailValues.push(-1);
                kpiFailColor.push("#858AFF");
            } else {
                kpiFailValues.push(0);
                kpiFailColor.push("#858AFF");
            }
        }
    }

    return (
        <div className="App">
            <div style={{ maxWidth: "70rem" }}>
                <Bar
                    data={{
                        labels: kpiLabels,
                        datasets: [
                            {
                                // Label for bars
                                label: "KPI pass",
                                // Data or value of your each variable
                                data: kpiPassValues,
                                // Color of each bar
                                backgroundColor: kpipassColor,
                                borderWidth: 0.5,
                            },
                            {
                                // Label for bars
                                label: "KPI fail",
                                data: kpiFailValues,
                                backgroundColor: kpiFailColor,
                                borderWidth: 0.5,
                            },
                        ],
                    }}
                    // Height of graph
                    height={250}
                    options={{
                        maintainAspectRatio: false,
                        // animation: false,
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    display: true,
                                    ticks: {
                                        // The y-axis value will start from zero
                                        // beginAtZero: true,
                                        min: -1,
                                        max: 1,
                                        stepSize: 1,
                                    },
                                },
                            ],
                        },
                        legend: {
                            display: true,
                            align: "end",
                            labels: {
                                fontSize: 15,
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
}

KpiStatusBarChart.propTypes = {
    kpiStatus: PropTypes.array,
};
KpiStatusBarChart.defaultProps = {
    kpiStatus: [],
};

export default KpiStatusBarChart;
